<template>
    <div :class="`pop-down ${ className }`">
        <div class="pop-down-content">
            <slot></slot>
        </div>
        <div class="pop-down-close" v-on:click="$emit('close')"></div>
    </div>
</template>

<script>
export default {
    name: 'PopDown',
    props: {
        className: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>
